import styled, { css } from 'styled-components';

type ChipVariant = 'up' | 'down' | 'flat' | 'amber' | 'neutral';

interface ChipProps {
  $variant?: ChipVariant;
}

const variants = {
  up: css`
    color: ${(p) => p.theme.color.semantic.up};
    background: ${(p) => p.theme.color.semantic.upBg};
    border-color: ${(p) => p.theme.color.semantic.upDim};
  `,
  down: css`
    color: ${(p) => p.theme.color.semantic.down};
    background: ${(p) => p.theme.color.semantic.downBg};
    border-color: ${(p) => p.theme.color.semantic.downDim};
  `,
  flat: css`
    color: ${(p) => p.theme.color.text[2]};
    background: ${(p) => p.theme.color.bg[2]};
    border-color: ${(p) => p.theme.color.border.soft};
  `,
  amber: css`
    color: ${(p) => p.theme.color.accent.amber};
    background: ${(p) => p.theme.color.accent.amberGlow};
    border-color: ${(p) => p.theme.color.accent.amberLine};
  `,
  neutral: css`
    color: ${(p) => p.theme.color.text[1]};
    background: ${(p) => p.theme.color.bg[2]};
    border-color: ${(p) => p.theme.color.border.soft};
  `,
};

export const Chip = styled.span<ChipProps>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid;
  font-size: ${(p) => p.theme.step[0]}px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  ${(p) => variants[p.$variant ?? 'neutral']}
`;
